module.exports = __webpack_public_path__ + "static/media/jav26.88b5b370.JPG";